// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// /Users/Eugen/.config/yarn/global/~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!/Users/Eugen/.config/yarn/global/~/vue-style-loader!/Users/Eugen/.config/yarn/global/~/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":false}!/Users/Eugen/.config/yarn/global/~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d1779b96","scoped":false,"hasInlineConfig":true}!/Users/Eugen/.config/yarn/global/~/vue-loader/lib/selector.js?type=styles&index=0!./src/js/components/StarRating.vue
// module id = 173
// module chunks = 0